import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from "src/app/providers/api.service";
import { BuisnessPromotion } from "src/app/models/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { StorageService } from "src/app/providers/storage.service";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import { CustomConfirmDialogComponent } from "../custom-confirm-dialog/custom-confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { DialogService } from "src/app/providers/dialog.service";
import { AddBusinessPostComponent } from "src/app/pages/new-v2-pages/new-v2-component/add-business-post/add-business-post.component";
import { CopyLinkCompComponent } from "src/app/pages/new-v2-pages/new-v2-component/copy-link-comp/copy-link-comp.component";
import { Platform } from "@ionic/angular";
import { Share } from "@capacitor/share";
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: "sm-admin-post-card",
  templateUrl: "./admin-post-card.component.html",
  styleUrls: ["./admin-post-card.component.scss"],
})
export class AdminPostCardComponent implements OnInit {
  @Input() postData: any;
  @Output()
  onOpenModel: EventEmitter<BuisnessPromotion> =
    new EventEmitter<BuisnessPromotion>();
  imageLink: { url: string; text: string } = {
    url: "https://images.unsplash.com/photo-1580618672591-eb180b1a973f?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
    text: "Hair Stylists having fun at Kulor Salon at 22 East Center Street in Logan. Utah.",
  };

  imageObject: Array<object> = [];

  slides = [
    {
      image:
        "https://images.unsplash.com/photo-1619630110059-13c4617ca2be?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    },
    { image: "https://picsum.photos/seed/picsum/1200/300" },
    {
      image:
        "https://images.unsplash.com/photo-1619630110059-13c4617ca2be?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    },
    { image: "https://picsum.photos/seed/picsum/1200/300" },
    { image: "https://picsum.photos/seed/picsum/1200/300" },
  ];

  constructor(
    private _apiService: ApiService,
    private _storageService: StorageService,
    private _router: Router,
    private ls: LoaderServiceService,
    private _activatedRoute: ActivatedRoute,
    private _modelRef: MatDialog,
    private dialogservice: DialogService,
    private platform: Platform
  ) {}

  onEditPromo() {
    this.onOpenModel.emit(this.postData);
  }

  onDeactivate() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Do you want to delete this post?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          postInfo: {
            hash_id: this.postData.hash_id,
            isDelete: "1",
          },
        };
        console.log(obj);

        this.ls.showLoader = true;
        this._apiService.updatePostInfo(obj, this.entityHash);
      }
    });
  }


    elatestposts: OwlOptions = {
    loop: true,
    margin: 10,
    autoplay: true,
    dots: true,
    // nav: true,
    // navText: [
    //   '<span class="material-icons">arrow_back</span>',
    //   '<span class="material-icons">arrow_forward</span>',
    // ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  showmore(item: any) {
    item.toshowmore = !item.toshowmore;
  }

  onAdminPostDetailClick() {
    this._storageService.setValueInAppStorage("adminPostData", this.postData);

    this._router.navigate(["admin-post-details"], {
      relativeTo: this._activatedRoute,
      skipLocationChange: true,
    });
  }
  entityHash: any = "";
  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((res) => {
      if (res) {
        this.entityHash = res.entityHash;
      }
    });
    // let imageArray: any[] = JSON.parse(this.postData.assetInfo);
    // // console.log(imageArray);
    // imageArray.map((v, i) => {
    //   let extension = v.imgUrl.substring(v.imgUrl.lastIndexOf('.') + 1);
    //   console.log(extension);
    //   if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
    //     this.imageObject.push({
    //       image: v.imgUrl,
    //       type: 'image',
    //     });
    //   }
    //   if (extension === 'mp4' || extension === 'avi') {
    //     this.imageObject.push({
    //       image: v.imgUrl,
    //       type: 'video',
    //     });
    //   }
    // });
    // console.log(this.imageObject);
  }
  onEdit(postdata: any) {
    let data = {
      data: postdata,
      private_hash_id: postdata.hash_id,
    };
    let dialogref = this.dialogservice.openFullScreenDialog(
      AddBusinessPostComponent,
      data
    );
    dialogref.afterClosed().subscribe((data) => {
      if (data) {
      }
    });
  }

  msg: any;
  async onShare(post: any) {
    if (this.platform.is("capacitor")) {
      this.msg = post.public_url;

      const shareIntent = await Share.share({
        text: this.msg,
      });
    } else {
      this._modelRef.open(CopyLinkCompComponent, {
        width: "400px",
        data: {
          title: "Share post",
          data: post.public_url,
        },
      });
    }
  }

   openlink(item:any){
   if (item.externalLink && item.externalLink !== '' && item.externalLink !== 'null') {
    let url = item.externalLink.trim();

    // Add https:// if missing
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }

    

    window.open(url, '_blank');
  }
  }
}
